import { sentenceCase } from "../../../constants";
import { AppCheckbox } from "../../../Libraries";
import styles from "./styles.module.css";

const CheckboxFilterContent = (props) => {
  const { options = [], selectedSet = new Set(), onToggleOption, preserveCase = false } = props;
  return (
    <div className={styles.checkboxOnlyList}>
      <ul className={styles.checkboxList}>
        {options.map((opt) => (
          <li
            key={opt.value}
            role="option"
            aria-selected={selectedSet.has(opt.value)}
            className={`${styles.checkboxItem} ${styles.checkboxItemAppCheckbox}`}
            onClick={() => onToggleOption?.(opt.value)}
          >
            <AppCheckbox
              checked={selectedSet.has(opt.value)}
              label={preserveCase ? opt.label : sentenceCase(opt.label)}

            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CheckboxFilterContent;
